module.exports = __webpack_public_path__ + "media/images/vp/mobileapps.android-499edb5332cbb5ab8b012f42e0de99f5.png";